<template>
    <div class="row mb-3">
        <div class="col-4">
            <div class="card shadow">
                <div class="card-header text-center bg-primary">Echéances</div>
                <div class="card-body">
                    <div v-if="reportingCountersAreSet" class="row">
                        <div class="col-6">
                            <b-button
                                class="btn-block text-white"
                                :variant="lateDeadlinesVariant"
                                title="Afficher les échéances en retard"
                                :disabled="reportingCounters.all.late === 0"
                                @click="goToLateDeadlines"
                            >
                                <span class="counter">
                                    {{ reportingCounters.all.late }}
                                </span>
                                <br />
                                EN RETARD
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                class="btn-block text-white"
                                :variant="soonDeadlinesVariant"
                                title="Afficher les échéances à venir"
                                :disabled="reportingCounters.all.soon === 0"
                                @click="goToSoonDeadlines"
                            >
                                <span class="counter">
                                    {{ reportingCounters.all.soon }}
                                </span>
                                <br />
                                A VENIR
                            </b-button>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-6">
                            <b-button
                                key="lateDeadlinesNotSet"
                                class="btn-block text-white"
                                variant="success"
                                disabled
                            >
                                <span class="counter"
                                    ><i
                                        class="far fa-spinner fa-spin"
                                    ></i></span
                                ><br />
                                EN RETARD
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                key="soonDeadlinesNotSet"
                                class="btn-block text-white"
                                variant="success"
                                disabled
                            >
                                <span class="counter"
                                    ><i
                                        class="far fa-spinner fa-spin"
                                    ></i></span
                                ><br />
                                A VENIR
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <div class="card shadow">
                <div class="card-header text-center bg-primary">TO DO</div>
                <div class="card-body">
                    <div v-if="ownTaskCountersAreSet" class="row">
                        <div class="col-6">
                            <b-button
                                v-if="todoCounters.hasOwnProperty('ownTasks')"
                                class="btn-block text-white"
                                :variant="lateOwnTasksVariant"
                                title="Afficher les tâches à réaliser en retard"
                                :disabled="todoCounters.ownTasks.late === 0"
                                @click="goToOwnLateTasks"
                            >
                                <span class="counter">{{
                                    todoCounters.ownTasks.late
                                }}</span
                                ><br />
                                EN RETARD
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                v-if="todoCounters.hasOwnProperty('ownTasks')"
                                class="btn-block text-white"
                                :variant="soonOwnTasksVariant"
                                title="Afficher les tâches à réaliser à venir"
                                :disabled="todoCounters.ownTasks.soon === 0"
                                @click="goToOwnSoonTasks"
                            >
                                <span class="counter">{{
                                    todoCounters.ownTasks.soon
                                }}</span
                                ><br />
                                A VENIR
                            </b-button>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-6">
                            <b-button
                                key="lateOwnTasksNotSet"
                                class="btn-block text-white"
                                variant="success"
                                disabled
                            >
                                <span class="counter"
                                    ><i
                                        class="far fa-spinner fa-spin"
                                    ></i></span
                                ><br />
                                EN RETARD
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                key="soonOwnTasksNotSet"
                                class="btn-block text-white"
                                variant="success"
                                disabled
                            >
                                <span class="counter"
                                    ><i
                                        class="far fa-spinner fa-spin"
                                    ></i></span
                                ><br />
                                A VENIR
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <div class="card shadow">
                <div class="card-header text-center bg-primary">TO BE DONE</div>
                <div class="card-body">
                    <div v-if="delegatedTaskCountersAreSet" class="row">
                        <div class="col-6">
                            <b-button
                                v-if="
                                    todoCounters.hasOwnProperty(
                                        'delegatedTasks'
                                    )
                                "
                                class="btn-block text-white"
                                :variant="lateDelegatedTasksVariant"
                                title="Afficher les tâches déléguées en retard"
                                :disabled="
                                    todoCounters.delegatedTasks.late === 0
                                "
                                @click="goToDelegatedLateTasks"
                            >
                                <span class="counter">{{
                                    todoCounters.delegatedTasks.late
                                }}</span
                                ><br />
                                EN RETARD
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                v-if="
                                    todoCounters.hasOwnProperty(
                                        'delegatedTasks'
                                    )
                                "
                                class="btn-block text-white"
                                :variant="soonDelegatedTasksVariant"
                                title="Afficher les tâches déléguées à venir"
                                :disabled="
                                    todoCounters.delegatedTasks.soon === 0
                                "
                                @click="goToDelegatedSoonTasks"
                            >
                                <span class="counter">{{
                                    todoCounters.delegatedTasks.soon
                                }}</span
                                ><br />
                                A VENIR
                            </b-button>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-6">
                            <b-button
                                key="lateDelegatedTasksNotSet"
                                class="btn-block text-white"
                                variant="success"
                                disabled
                            >
                                <span class="counter"
                                    ><i
                                        class="far fa-spinner fa-spin"
                                    ></i></span
                                ><br />
                                EN RETARD
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                key="soonDelegatedTasksNotSet"
                                class="btn-block text-white"
                                variant="success"
                                disabled
                            >
                                <span class="counter"
                                    ><i
                                        class="far fa-spinner fa-spin"
                                    ></i></span
                                ><br />
                                A VENIR
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'HomeButtons',

    computed: {
        ...mapState({
            initCompleted: (state) => state.browsing.initCompleted,
            reportingCounters: (state) => state.reportingVM.counters,
            reportingCountersAreSet: (state) =>
                state.reportingVM.reportingCountersAreSet,
            ownTaskCountersAreSet: (state) =>
                state.todoVM.OwnTaskCountersAreSet,
            delegatedTaskCountersAreSet: (state) =>
                state.todoVM.DelegatedTaskCountersAreSet,
            todoCounters: (state) => state.todoVM.counters,
            filters: (state) => state.reportingVM.filters,
        }),

        lateDeadlinesVariant() {
            return this.reportingCounters.all.late === 0 ? 'success' : 'danger'
        },

        soonDeadlinesVariant() {
            return this.reportingCounters.all.soon === 0 ? 'success' : 'warning'
        },

        lateOwnTasksVariant() {
            return this.todoCounters.ownTasks.late === 0 ? 'success' : 'danger'
        },

        soonOwnTasksVariant() {
            return this.todoCounters.ownTasks.soon === 0 ? 'success' : 'warning'
        },

        lateDelegatedTasksVariant() {
            return this.todoCounters.delegatedTasks.late === 0
                ? 'success'
                : 'danger'
        },

        soonDelegatedTasksVariant() {
            return this.todoCounters.delegatedTasks.soon === 0
                ? 'success'
                : 'warning'
        },
    },

    methods: {
        goToLateDeadlines() {
            // this.$store.commit('browsing/SET_DEADLINE_FILTER', 'late')
            this.$store.commit('browsing/SET_PAGE_NAME', 'deadlines')
            window.location.href = 'pilotage-activite/activite/echeances'
        },
        goToSoonDeadlines() {
            // this.$store.commit('browsing/SET_DEADLINE_FILTER', 'soon')
            this.$store.commit('browsing/SET_PAGE_NAME', 'deadlines')
            window.location.href = 'pilotage-activite/activite/echeances'
        },
        goToOwnLateTasks() {
            this.$store.commit('browsing/SET_TODO_FILTER', 'late')
            this.$store.commit('browsing/SET_PAGE_NAME', 'ownTasks')
            window.location.href = 'pilotage-activite/mes-taches/a-faire'
        },
        goToOwnSoonTasks() {
            this.$store.commit('browsing/SET_TODO_FILTER', 'soon')
            this.$store.commit('browsing/SET_PAGE_NAME', 'ownTasks')
            window.location.href = 'pilotage-activite/mes-taches/a-faire'
        },
        goToDelegatedLateTasks() {
            this.$store.commit('browsing/SET_TODO_FILTER', 'late')
            this.$store.commit('browsing/SET_PAGE_NAME', 'delegatedTasks')
            window.location.href = 'pilotage-activite/mes-taches/deleguees'
        },
        goToDelegatedSoonTasks() {
            this.$store.commit('browsing/SET_TODO_FILTER', 'soon')
            this.$store.commit('browsing/SET_PAGE_NAME', 'delegatedTasks')
            window.location.href = 'pilotage-activite/mes-taches/deleguees'
        },
    },
}
</script>

<style scoped>
.counter {
    font-size: 24px;
}

.card-title {
    color: #333;
    font-size: 20px;
    text-align: center;
}
</style>
